import styled from "styled-components";

export const FiltersContainer = styled.div`
  height: inherit;
  display: flex;
  flex-direction: row;
  column-gap: ${(props) => props.theme?.Filters?.gapBetweenFilters ?? "1rem"};
  width: 100%;
`;
